/**
 * Created by DSadler on 02/05/2017.
 */
import * as actions from './actions';

export function emails (state = [], action) {
  switch (action.type) {
    case actions.CREATE_EMAIL:
      return state;
    case actions.UPDATE_EMAIL:
      return state;
    case actions.DELETE_EMAIL:
      return state;
    case actions.SET_EMAILS:
      return state;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/App/state/emails/reducers.js